import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M2.5 1V19.5H5.50001L5.5 14.0566H7L7.00001 19.5H10.5L10.5 12.0479H12L12 19.5H15.5L15.5 10.0391H17L17 19.5H21V21H1V1H2.5Z" />
    <path d="M16.9649 3.96488L12.4995 8.43891L10.0001 5.93943L4.46973 11.4698L5.53039 12.5304L10.0001 8.06075L12.5006 10.5613L18.0255 5.02554L20 7V2H15L16.9649 3.96488Z" />
  </svg>
);
